export function validMinLength(field) {
    return (
        field.value.length >= parseInt(field.getAttribute("data-min-length"))
    );
}
